export default __webpack_public_path__ + "static/media/id-min.29660099.png";